import type { GetProps } from "antd";
import { InputNumber } from "antd";
type FormatterType = GetProps<typeof InputNumber>["formatter"];
export const inputNumberFormatter: FormatterType = (value) =>
  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
